<!--
 * @Author: hai.zhang
 * @LastEditors: xuxiaofei
-->
<template>
  <div class="sy-im-box" :class="[{ 'hide-contact-list': !showContentList }]"  v-show="isShow">
    <imHead @hideIm="hide" :activeMsgItem=activeMsgItem :toUserInfo="toUserInfo"></imHead>
    <div class="sy-im-content syue-clr" :style="'background-image:url('+bgUrl+')'" v-if="allMessagesList.length > 0">
      <div class="sy-im-content-left syue-left">
        <contactList @selectMsgItem="selectMsgItem" v-if="showContentList" :activeMsgItem=activeMsgItem :allMessagesList="allMessagesList" ></contactList>
      </div>
      <div class="sy-im-content-right syue-left">
        <chat-window 
          ref="chat-window" 
          :isShow="isShow" 
          :toUserInfo="toUserInfo"
          :activeMsgItem=activeMsgItem
          :acceptorId="acceptorId"
          :acceptorInfo="acceptorInfo"
          :fromId="fromId"
          @sendMsg="sendMsg"
          @pretestMsg="pretestMsg"
          ></chat-window>
      </div>
    </div>
    <div v-else class="no-data">
      <img :src="syImgUrl+'162847544581840273.svg'" />
      <p>暂无内容</p>
    </div>
  </div>
</template>

<style scoped lang="scss" >
.sy-im-box{
  border-radius: 5px;
  overflow: hidden;
  position: fixed;
  background: #fff;
  width: 700px;
  height: 548px;
  z-index: 2000;
  box-shadow: 0 8px 30px 0 rgba(0, 0, 0, 0.5);
  right: 20px;
  bottom: 20px;
  .no-data{
    text-align: center;
    padding-top: 180px;
    p {
      padding-top: 12px;
      line-height: 18px;
      color: 12px;
    }
  }
  .sy-im-content{
    background-repeat: repeat;
    height: calc(100% - 56px);
    background-position: 0 0;
  }
  .sy-im-content-left{
    width: 200px;
    height: 100%;
    overflow: auto;
    position: relative;
    box-shadow: 2px -1px 4px 0px rgba(187,187,187,0.3);
  }
  .sy-im-content-right{
    width: calc(100% - 200px);
    height: 100%;
  }
  &.hide-contact-list{
    width: 500px;
    .sy-im-content-left {
      display: none;
    }
    .sy-im-content-right{
      width: 100%;
    }
  }
}
</style>

<script>
import imHead from './components/head.vue'
import contactList from './components/contact-list.vue'
import chatWindow from './components/chat-window.vue'
import Api from './api'
import response from '../../../utils/response/index.js'
import { imgAddHost } from '@/utils/index.js'
// import { Root } from 'protobufjs'
// import json from './config/Message.json'
import moment from 'moment'
import mixin from './mixin'
import { cloneDeep, assign } from 'lodash-es'
import { getUserInfo } from '../paas/store/local-catch/user'
import io from 'socket.io-client'
export default {
  mixins: [ mixin ],
  components: {
    imHead,
    contactList,
    chatWindow
  },
  props: {
  },
  data () {
    // console.log(getUserInfo())
    const userINfo = getUserInfo()
    return {
      isShow: false,
      // 背景url
      bgUrl: '',
      // 应用表单code
      applyFormCode: '',
      // 发起端
      clientType: '',
      // 单据id
      acceptorId: '',
      // 聊天人id 
      toId: '',
      fromId: userINfo.id,
      // 聊天人信息
      toUserInfo: {},
      acceptorInfo: {},
      // 所有聊天数据
      allMessagesList: [],
      // 显示聊天人列表
      showContentList: false,
      // 定时器
      timer: null
    }
  },
  created () {
  },
  methods: {
    // 显示聊天窗口
    async show (obj) {
      this.isShow = true
      await this.init(obj)
      await this.getBackgroundUrl()
      // this.$nextTick(() => {
      // })
    },
    async getHistoryList () {
      // this.$nextTick(function () {
      await this.$refs['chat-window'].getHistoryList()
      // this.scrollBottom()
      // })
    },
    // websoket 心跳
    heartbeat () {
      this.timer = setInterval(() => {
        this.scoket.emit('checkTokenIsValid', {}, (data) => {
          console.log(data)
        })
        // this.socket.send(Message.encode(msg).finish())
      }, 25000)
    },
    // 隐藏聊天窗口
    hide () {
      this.isShow = false
      this.allMessagesList = []
      // this.$set(this, 'allMessagesList', [])
      this.scoket && this.scoket.disconnect()
      this.scoket = null
      clearInterval(this.timer)
      // this.socket.close()
    },
    async init (obj) {
      let contentList = []
      this.showContentList = obj.showContentList
      this.clientType = obj.clientType
      if (obj.showContentList) {
        const list = await this.getContentList()
        list.forEach(item => {
          item.lastMsg = {
            lastMsgType: item.lastMsg,
            lastSendMessage: item.lastSendMessage,
            lastSendMsgId: item.lastSendMsgId,
            sendTime: item.sendTime
          }
          item.acceptorId = item.bizDataCode
          item.clientType = obj.clientType
        })
        contentList.push(...list)
      } else {
        // console.log(obj, 6666)
        contentList.push(obj)
      }
      contentList.forEach(item => {
        this.initMessage(item)
      })
      this.allMessagesList.length > 0 ? await this.selectMsgItem(this.allMessagesList[0]) : this.creatWs()
    },
    async selectMsgItem (item) {
      this.setData(item)
      this.creatWs()
      item.unreadNum = 0
      await this.$nextTick(async function () {
        await this.getHistoryList()
        // this.isShow = true
      })
    },
    //  设置聊天信息
    setData (obj) {
      this.applyFormCode = obj.applyFormCode
      this.acceptorId = obj.acceptorId
      this.toId = obj.toId
      this.toUserInfo = obj.toUserInfo || {}
      this.acceptorInfo = obj.acceptorInfo || {}
      // this.showContentList = obj.showContentList
    },
    async getContentList () {
      const api = Api.selectUserGroupList
      const res = await response(this.$http(api.type, api.url, {
        clientType: this.clientType
      }))
      if (res.isOk) {
        return res.content || []
      } else {
        this.$message.error('获取联系人失败')
        return []
      }
    },
    // 初始化一个聊天消息
    initMessage (obj) {
      let index = this.allMessagesList.findIndex(item => {
        return item.applyFormCode === obj.applyFormCode && item.clientType === obj.clientType && item.acceptorId === obj.acceptorId && item.toId === obj.toId
      })
      if (index === -1) {
        // console.log('toClientType', obj.toClientType, obj.acceptClientType)
        let msgItem = {
          applyFormCode: obj.applyFormCode,
          clientType: obj.clientType || this.clientType,
          toClientType: obj.toClientType || obj.acceptClientType,
          acceptorId: obj.acceptorId || obj.bizDataCode,
          toId: obj.toId,
          toName: obj.toName || (obj.toUserInfo && obj.toUserInfo.name),
          unreadNum: obj.unreadNum || 0,
          extendParam: obj.extendParam,
          lastMsg: obj.lastMsg,
          applyFormName: obj.applyFormName,
          buyerUrl: obj.buyerUrl,
          demandUsersUrl: obj.demandUsersUrl,
          supplierUrl: obj.supplierUrl,
          toSupplierName: obj.toSupplierName,
          toSupplierId: obj.toSupplierId,
          allLoaded: false,
          seq: 0,
          frontMsgId: new Date().getTime(),
          msgList: []
        }
        this.allMessagesList.push(msgItem)
        return msgItem
      }
      return this.allMessagesList[index]
    },
    // 获取背景url
    async getBackgroundUrl () {
      const api = Api.createBackgroundImage 
      const res = await response(this.$http(api.type, api.url, {
        clientType: this.clientType
      }))
      if (res.isOk) {
        this.bgUrl = imgAddHost(res.content.url)
      }
    },
    // 创建websoket 实例
    creatWs () {
      let self = this
      // const io = io
      if (this.scoket) {
        return false
      }
      this.scoket = io(`${window.location.protocol}//${window.location.host}/im?clientType=${this.clientType}`, { path: '/im', transports: ['websocket', 'polling'] })
      this.scoket.onopen(() => {
        // this.socket.send('Hello!')
      })
      this.scoket.on('chat_event_from', data => {
        this.handleMessage(JSON.parse(data), true)
      })
      this.scoket.on('chat_event_receive', data => {
        this.handleMessage(JSON.parse(data))
      })
      this.scoket.on('disconnect', function () { 
        // console.log('aaa')
        if (self.isShow) {
          self.hide()
          self.$message.error('会话已关闭')
        }
        // this.scoket.disconnect()
      })
      this.heartbeat()
      // window.fe.scoket = this.scoket
    },
    // 滚动到聊天消息底部
    scrollBottom () {
      this.$nextTick(function () {
        this.$refs['chat-window'].scrollBottom()
      })
    },
    // 处理收到消息
    handleMessage (data, isMe) {
      const message = this.handleData([data.content])[0]
      if (data.code === 'success') {
        let msgItem = this.allMessagesList.find(item => {
          return item.acceptorId.toString() === message.bizDataCode.toString() && item.applyFormCode.toString() === message.applyFormCode.toString() && item.toId.toString() === message.toId.toString()
        })
        // 接受
        if (!msgItem) {
          msgItem = this.initMessage(data.content)
          this.allMessagesList.length === 1 && this.selectMsgItem(msgItem)
        }
        msgItem.msgList.push(assign(message, isMe ? {} : { fromId: message.toId }))
        this.placedTop(msgItem)
        if (this.activeMsgItem === msgItem) {
          this.scrollBottom()
          !isMe && this.updateMsgStatus(message.msgId)
        } else {
          !isMe && msgItem.unreadNum++
        }
      }
    },
    // 初始化消息 
    initMsgData (obj) {
      return assign(obj, {
        cmdId: 1,
        destType: 1,
        toId: this.toId,
        toName: this.activeMsgItem.toName,
        fromId: this.fromId,
        // sendTime: new Date(),
        toSupplierName: this.activeMsgItem.toSupplierName,
        toSupplierId: this.activeMsgItem.toSupplierId,
        buyerUrl: this.activeMsgItem.buyerUrl,
        demandUsersUrl: this.activeMsgItem.demandUsersUrl,
        supplierUrl: this.activeMsgItem.supplierUrl,
        showTime: moment(new Date()).format('HH:mm'),
        clientType: this.activeMsgItem.clientType,
        extendParam: this.activeMsgItem.extendParam,
        toClientType: this.activeMsgItem.toClientType,
        seq: ++this.activeMsgItem.seq,
        frontMsgId: new Date().getTime(),
        applyFormCode: this.activeMsgItem.applyFormCode,
        bizDataCode: this.activeMsgItem.acceptorId
      })
    },
    // (用于组装不同类型消息) 
    getParameter (obj) {
      if (obj.type === 'heartbeat') {
        return {
          cmdId: 5
        }
      } else if (obj.type === 'text') {
        return this.initMsgData({
          msgBody: obj.msg,
          msgType: 1
        })
      } else if (obj.type === 'file') {
        return this.initMsgData({
          msgBody: JSON.stringify({
            filePath: obj.msg.filePath,
            key: obj.msg.key,
            openUrl: obj.msg.openUrl,
            originalName: obj.msg.originalName
          }),
          msgType: 2
        })
      } else if (obj.type === 'inform-reply') {
        return {
          cmdId: 4,
          ackMsgId: obj.ackMsgId,
          msgId: obj.msgId
        }
      }
    },
    // 预发送消息 用于文件发送 展示进度条 
    pretestMsg (obj) {
      let parameter = this.initMsgData({ msgBody: obj })
      parameter.showTime = moment(new Date().getTime()).format('HH:mm')
      parameter.msgBody = JSON.stringify(parameter.msgBody) 
      parameter.msgType = 2
      this.activeMsgItem.msgList.push(this.handleData([parameter])[0])
      this.scrollBottom()
    },
    // 置顶
    placedTop (obj) {
      let index = this.allMessagesList.findIndex(item => {
        return item === obj
      })
      if (index !== -1 && index !== 0) {
        let item = this.allMessagesList.splice(index, 1)[0]
        this.allMessagesList.unshift(item)
      }
    },
    // 发送消息
    sendMsg (obj) {
      // let Message = this.Message
      let parameter = cloneDeep(this.getParameter(obj))
      // let msg = Message.encode(Message.create(parameter)).finish()
      // const encode = Message.encode(msg).finish()
      this.placedTop(this.activeMsgItem)
      this.scoket.emit('chatEvent', parameter, (data) => {
        data = JSON.parse(data)
        if (data.code !== 'success') {
          const message = this.handleData([data.content])[0]
          const errorMsgItem = this.allMessagesList.find(item => {
            return item.acceptorId.toString() === message.bizDataCode.toString() && item.applyFormCode.toString() === message.applyFormCode.toString() && item.toId.toString() === this.toId.toString()
          })
          if (errorMsgItem) {
            let messageItemIndex = errorMsgItem.msgList.findIndex(item => {
              return item.frontMsgId === parseInt(message.frontMsgId)
            })
            messageItemIndex !== -1 && errorMsgItem.msgList.splice(messageItemIndex, 1)
          }
          this.$message.error(data.errorMessage)
        }
      })
      if (parameter.cmdId === 1) {
        parameter.sendTime = new Date()
        this.activeMsgItem.msgList.push(this.handleData([parameter])[0])
      }
    }
  },
  computed: {
    activeMsgItem: function () {
      return this.allMessagesList.find(item => {
        return item.applyFormCode === this.applyFormCode && item.clientType === this.clientType && item.acceptorId === this.acceptorId && item.toId === this.toId
      }) || {}
    }
    // lastSeq () {
    //   let list = this.activeMsgItem.msgList || []
    //   return list.length > 0 ? list[list.length - 1].seq : 0
    // }
  }
}
</script>
